<template>
  <error-page error="404"></error-page>
</template>

<script>
import ErrorPage from './components/general/ErrorPage.vue';

export default {
  components: {
    ErrorPage,
  },
};
</script>



/** WEBPACK FOOTER **
 ** NotFound.vue?ece17e5a
 **/